import { render, staticRenderFns } from "./bindCard.vue?vue&type=template&id=4a56a291&scoped=true"
import script from "./bindCard.vue?vue&type=script&lang=js"
export * from "./bindCard.vue?vue&type=script&lang=js"
import style0 from "./bindCard.vue?vue&type=style&index=0&id=4a56a291&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a56a291",
  null
  
)

export default component.exports